import { AddressBook } from "@phosphor-icons/react";
import { Message } from "../../../models/Message";
import { getContactDisplayName, getContactPhones, parseContactMessage } from "../../../utils/specialMessages";
import { SharedContactView } from "./styles";

export interface SharedContactValue {
  name: string;
  phone: string;
};

export interface SharedContactProps {
  message: Message;
  onSaveContact?: ( contact: SharedContactValue ) => void;
  onStartConversation?: ( contact: SharedContactValue ) => void;
};

export const SharedContact = ({ message, onSaveContact, onStartConversation }: SharedContactProps ) => {
  const contacts = parseContactMessage( message );
  const first = contacts[ 0 ];
  const name = getContactDisplayName( first );
  const phone = getContactPhones( first )[ 0 ];
  const remaining = contacts.length - 1;
  const contact = {
    name,
    phone: phone ?? "",
  };

  return (
    <SharedContactView>
      <div className="contact-card">
        <div className="contact-row">
          <div className="contact-icon">
            <AddressBook
              size={ 28 }
              weight="duotone"
            />
          </div>

          <div className="contact-info">
            <strong>{ name }</strong>

            {
              phone ? <span>{ phone }</span> : <span>Contato compartilhado</span>
            }
          </div>
        </div>

        {
          remaining > 0 ? <span className="more-contacts">+{ remaining } contato{ remaining > 1 ? "s" : "" }</span> : <></>
        }

        <div className="contact-actions">
          <button
            type="button"
            onClick={( event ) => {
              event.preventDefault();
              event.stopPropagation();
              onSaveContact?.( contact );
            }}
          >
            Salvar
          </button>

          <button
            type="button"
            disabled={ !phone }
            onClick={( event ) => {
              event.preventDefault();
              event.stopPropagation();
              onStartConversation?.( contact );
            }}
          >
            Conversar
          </button>
        </div>
      </div>
    </SharedContactView>
  );
};
